import { render, staticRenderFns } from "./SubelementShowOptionsTab.vue?vue&type=template&id=3789db56"
import script from "./SubelementShowOptionsTab.vue?vue&type=script&lang=ts"
export * from "./SubelementShowOptionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports